import type { RouteObject } from 'react-router-dom';

import AuthLayout from '@/app/layouts/AuthLayout/AuthLayout';
import { GuestGuard } from '@/app/router/guards';
import { lazyRoute } from '@/app/router/helpers';
import { ROUTES } from '@/shared/constants/app/routes.constant.ts';

export const authRoutes: RouteObject = {
  Component: AuthLayout,
  path: ROUTES.AUTH,
  children: [
    // ── Public ────────────────────────
    {
      path: ROUTES.VERIFY_EMAIL,
      ...lazyRoute(() => import('@/pages/auth/VerifyEmailPage')),
    },
    {
      path: ROUTES.RESET_PASSWORD,
      ...lazyRoute(() => import('@/pages/auth/ResetPasswordPage')),
    },
    {
      path: ROUTES.CONFIRM_EMAIL_CHANGE,
      ...lazyRoute(() => import('@/pages/auth/ConfirmEmailChangePage')),
    },

    // ── Guest ────────────────────────
    {
      element: <GuestGuard />,
      children: [
        {
          path: ROUTES.LOGIN,
          ...lazyRoute(() => import('@/pages/auth/LoginPage')),
        },
        {
          path: ROUTES.SIGNUP,
          ...lazyRoute(() => import('@/pages/auth/SignupPage')),
        },
        {
          path: ROUTES.REQUEST_PASSWORD_RESET,
          ...lazyRoute(
            () => import('@/pages/auth/RequestPasswordResetPage'),
          ),
        },
        {
          path: ROUTES.FIND_LOGIN_ID,
          ...lazyRoute(() => import('@/pages/auth/FindLoginIdPage')),
        },
      ],
    },

    // ── 첫 로그인 온보딩 ──────────────
    // GuestGuard 아래 두면 안 된다 — 로그인한 상태로 들어오는 화면이다.
    // 접근 제한은 Gateway 가 status=PENDING_ONBOARDING 으로 처리하므로 여기선
    // 라우트만 열어 둔다(온보딩이 끝난 계정은 View 가 스스로 빠져나간다).
    {
      path: ROUTES.ONBOARDING,
      ...lazyRoute(() => import('@/pages/auth/OnboardingPage')),
    },

    // ── 약관 재동의 ──────────────
    // 온보딩과 같은 이유로 GuestGuard·AuthGuard 밖에 둔다 — AuthGuard 가 재동의 대상을 이리로 보낸다.
    // 접근 제한은 Gateway 가 토큰의 재동의 클레임으로 처리한다.
    {
      path: ROUTES.RECONSENT,
      ...lazyRoute(() => import('@/pages/auth/ReconsentPage')),
    },
  ],
};